// @flow

const AUTH_KEY = 'auth';
const PATIENT_FILTERS_KEY = 'patientFilters';
const ALERT_FILTERS_KEY = 'alertFilters';
const LAST_ACTIVITY_KEY = 'lastActivity';
const APOLLO_CACHE_KEY = 'apollo-cache-persist';
const PATIENTS_APOLLO_CACHE_KEY = 'apollo-cache-persist-patients';

export const clearSessionStorage = () => {
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(PATIENT_FILTERS_KEY);
  localStorage.removeItem(ALERT_FILTERS_KEY);
  localStorage.removeItem(LAST_ACTIVITY_KEY);
  localStorage.removeItem(APOLLO_CACHE_KEY);
  localStorage.removeItem(PATIENTS_APOLLO_CACHE_KEY);
};

export const getSessionItem = (key: string) => localStorage.getItem(key);

export const setSessionItem = (key: string, value: any) => localStorage.setItem(key, value);

export const removeSessionItem = (key: string) => localStorage.removeItem(key);
